import { useEffect, useState } from 'react';
import type { ApiClient } from '../api/client';

export default function FenceConnectionLink({ apiClient }: { apiClient: ApiClient }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let active = true;
    apiClient.get<{ connect_url: string }>('/api/ai-fence/connection').then(value => {
      const target = new URL(value.connect_url);
      if (active && ['https:', 'http:'].includes(target.protocol)) setUrl(target.toString());
    }).catch(() => {});
    return () => { active = false; };
  }, [apiClient]);
  return url ? <a className="assistant-sources-link" href={url} target="_blank" rel="noopener noreferrer">Connect or authorize your subscription in Fence ↗</a> : null;
}
